import React from 'react';
import { FileText, Clock } from 'lucide-react';

interface HeroStatsBlockProps {
  totalPrompts: number;
  favoritePrompts: number;
  templatePrompts: number;
  mostUsedPlatform: string;
  recentActivity: number;
  totalTags: number;
  creationStreak: number;
}

export const HeroStatsBlock: React.FC<HeroStatsBlockProps> = ({
  totalPrompts,
  recentActivity,
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
      {/* Total Prompts */}
      <div className="bg-gradient-to-br from-white to-gray-50/50 dark:from-dark-surface dark:to-dark-card 
        border border-gray-200/60 dark:border-dark-border rounded-xl p-6 shadow-sm dark:shadow-dark-card 
        hover:shadow-md dark:hover:shadow-dark-elevated transition-all duration-200">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-gray-600 dark:text-gray-400 mb-1">Total Prompts</p>
            <p className="text-3xl font-bold text-gray-900 dark:text-dark-text">{totalPrompts}</p>
          </div>
          <div className="h-12 w-12 bg-blue-50 dark:bg-blue-900/30 rounded-lg flex items-center justify-center">
            <FileText className="h-6 w-6 text-blue-600 dark:text-blue-400" />
          </div>
        </div>
      </div>

      {/* Recent Activity */}
      <div className="bg-gradient-to-br from-white to-gray-50/50 dark:from-dark-surface dark:to-dark-card 
        border border-gray-200/60 dark:border-dark-border rounded-xl p-6 shadow-sm dark:shadow-dark-card 
        hover:shadow-md dark:hover:shadow-dark-elevated transition-all duration-200">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-gray-600 dark:text-gray-400 mb-1">Recent Activity</p>
            <p className="text-3xl font-bold text-gray-900 dark:text-dark-text">{recentActivity}</p>
          </div>
          <div className="h-12 w-12 bg-emerald-50 dark:bg-emerald-900/30 rounded-lg flex items-center justify-center">
            <Clock className="h-6 w-6 text-emerald-600 dark:text-emerald-400" />
          </div>
        </div>
      </div>
    </div>
  );
};